module.exports = function(app) {
	'use strict';

	app.directive('eprProviders', function() {
		return {
			restrict: 'A',
			replace: false,
			templateUrl:'_directives.employerTemplate.html/directives/employee/eprProviders',

			scope: {
				employee: '=eprProviders',
				editMode: '=?',
				groupNumber: '=?',
				productEffectiveDate: '=?',
				additionalGroupInformation: '=?'
			},

			controller: ['$state', '$scope', 'employee', 'services', 'coverageBuddy','$rootScope', function ($state, $scope, employee, services, coverageBuddy, $rootScope) {
				var employeeMetadata = employee.metadata;

				$scope.hasProviderData = function(p) {
					var coverage = coverageBuddy.getCoveragesByGroupNumber(p, $scope.groupNumber)[0];
					return (
						coverage &&
						coverage.providerInformation &&
						(coverage.providerInformation.physicianName || coverage.providerInformation.physicianNumber)
					);
				};

				var hasMedicalInGroup = function(p, groupNumber) {
					var coverageForGroupNumber = coverageBuddy.getCoveragesByGroupNumber(p, groupNumber)[0];
					return (
						coverageForGroupNumber &&
						Array.isArray(coverageForGroupNumber.memberLobs) &&
						coverageForGroupNumber.memberLobs.some(function(lob) { return lob.coverageType === 'MEDICAL'; })
					);
				};

                // $rootScope.$on('updateProvidersonRevert', function(event, additInfo) {
				// 	$scope.additionalGroupInfo = additInfo;
				// });

				$scope.hideOnSummaryEdit = function(groupNumber) {
					if (!(groupNumber && $state.current && $state.current.name === 'employee.find.review')) {
						return false;
					}
                    else if ($scope.additionalGroupInformation && $scope.additionalGroupInformation.providerRequired) {
                        return false;
                    }
					else if ($scope.additionalGroupInformation && $scope.additionalGroupInformation.physicianOfRecord) {
						return false;
					}
					else {
						var hasNoExistingProvidersForGroupNumber = coverageBuddy.getParticipantsWithProviders($scope.employee.data, groupNumber).length === 0;
						var newParticipants = [$scope.employee.data.subscriber].concat($scope.employee.data.dependents).filter(function(p) { return !p.pin; });
						var hasNoParticipantsAddedToGroup = newParticipants.every(function(p) { return !hasMedicalInGroup(p, groupNumber); });
						return hasNoExistingProvidersForGroupNumber && hasNoParticipantsAddedToGroup;
					}
				};

				$scope.dependentShouldShow = function(d, i) {
					if (
						$state.current.name &&
						($state.current.name.indexOf('employee.add') >= 0 || $state.current.name === 'employee.find.addCoverage')
					) {
						if (!$scope.editMode) {
							return $scope.hasProviderData(d);
						}
						else {
							return (
								employeeMetadata.planCoverageOptIn &&
								employeeMetadata.planCoverageOptIn.dependents[i] &&
								employeeMetadata.planCoverageOptIn.dependents[i].medical
							);
						}
					}
					if ($state.current.name && $state.current.name === 'employee.find.review') {
						var currentGroup = coverageBuddy.getCoveragesByGroupNumber($scope.employee.data.subscriber, $scope.groupNumber)[0];
						var subscriberHasProviderInformation = currentGroup && currentGroup instanceof Object && currentGroup.providerInformation;
						var agi = $scope.additionalGroupInfo || {};
						var groupCanHaveProvider = (agi.providerRequired || agi.primaryCarePhysician || agi.physicianOfRecord);

						if (groupCanHaveProvider || subscriberHasProviderInformation) {
							var currentGroupInDependent = coverageBuddy.getCoveragesByGroupNumber(d, $scope.groupNumber)[0];
							var dependentProviderInformation = currentGroupInDependent && currentGroupInDependent.providerInformation || {};

							return $scope.editFlowEditMode(d)
								? hasMedicalInGroup(d, $scope.groupNumber)
								: dependentProviderInformation.physicianName || dependentProviderInformation.physicianNumber;
						}
					}
				};

				$scope.editFlowEditMode = function(p) {
					if (
						$state.current &&
						$state.current.name !== 'employee.find.review' &&
						$state.current.name !== 'employee.find.addCoverage'
					) {
						return false;
					}
					else if ($scope.additionalGroupInfo && $scope.additionalGroupInfo.physicianOfRecord) {
						return true;
					}
					else if (!p.pin) {
						return true;
					}
					else if (
						coverageBuddy.getCoveragesByGroupNumber(p, $scope.groupNumber).length > 0 && // existing employee has this group in temporary data
						coverageBuddy.getCoveragesByGroupNumber(employee.getParticipantByPIN(p.pin), $scope.groupNumber).length === 0 // but does not have it in saved data
					) {
						return true;
					}
					else {
						return false;
					}
				};


				var selectedProduct;
				var additionalGroupInfo;

				$scope.isCoverageStep = $state.current && $state.current.name === 'employee.add.coverage';

				$scope.$on('medicalPlanUpdated', function(event, additionalGroupInformation, product, planCoverageOptIn, groupNumber, productEffectiveDate) {
					console.debug('heard medicalPlanUpdated');
					selectedProduct = null;
					additionalGroupInfo = null;

					$scope.planCoverageOptIn = planCoverageOptIn;
					selectedProduct = product;
					additionalGroupInfo = additionalGroupInformation;
					$scope.additionalGroupInfo = additionalGroupInfo;
					$scope.productEffectiveDate = productEffectiveDate;
				});

				if ($scope.groupNumber && $scope.productEffectiveDate) { // For edit flow
					services.eprsvc.additionalGroupInformation({ groupNumber: $scope.groupNumber }).fetch($scope.productEffectiveDate).then(
						function(response) {
							var additionalGroupInformation = response && response.data && response.data.payload;
							if (additionalGroupInformation) {
								$scope.additionalGroupInfo = additionalGroupInformation;
							}
						},
						function() {
						}
					);
				}

				var providersNeeded;
				var validationsReceived;
				var successfulValidations;

				$scope.$on('assignProviders', function() {
					console.debug('heard assignProviders');
					if ($scope.planCoverageOptIn && $scope.planCoverageOptIn.subscriber && $scope.planCoverageOptIn.subscriber.medical) {

						providersNeeded = $scope.planCoverageOptIn.dependents.filter(function(d) {
							return d.medical;
						}).length + 1;

						validationsReceived = 0;
						successfulValidations = 0;

						$scope.$broadcast('validateProvider', additionalGroupInfo, selectedProduct);
						$scope.employee.isLoading = true;
					}
					else {
						$scope.$emit('providersAssigned', true);
					}
				});

				$scope.$on('providerValidated', function(event, validationSucceeded) {
					console.debug('heard providerValidated');
					++validationsReceived;
					if (validationSucceeded) { ++successfulValidations; }

					if (validationsReceived === providersNeeded) {
						$scope.employee.isLoading = false;
						if (successfulValidations === providersNeeded) {
							$scope.$broadcast('assignProvider', selectedProduct);
						}
						else { $scope.$emit('providersAssigned', false); }
					}
				});

				$scope.$on('providerAssigned', function() {
					console.debug('heard providerAssigned', providersNeeded, 'providers needed');

					if (!(--providersNeeded)) {
						$scope.$emit('providersAssigned', true);
					}
				});
			}]
		};
	});
};
